import { Box, Paper } from '@mui/material';
import Templete from '../../template/Template';

import WhatsAppConfiguration from './WhatsAppConfiguration';

const WhatsappContainer = () => {
    return (
        <Templete menuActive='whatsapp'>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Paper
                    elevation={2}
                    sx={{
                        p: { xs: 2, sm: 4 },
                        borderRadius: 2,
                        overflow: 'hidden'
                    }}
                >
                    <WhatsAppConfiguration />
                </Paper>
            </Box>
        </Templete>
    );
};

export default WhatsappContainer;